import { BaseEntitiesState } from '../documents.state';

export interface WorklistIntegrationsState {
  entities: BaseEntitiesState<any>; // using any here as we don't want to break too many things
}

export const INITIAL_WORKLIST_INTEGRATIONS_STATE: WorklistIntegrationsState = {
  entities: {},
};
